<template>
  <div class="container-fluid">

    <div class="botonera-resultats">
        <b-button-group size="sm">        
        <b-button size="sm" v-b-toggle.collapse-filtre  variant="outline-primary">
          <b-icon icon="gear" aria-hidden="true"></b-icon>
        </b-button>
        </b-button-group>
    </div>

    <b-collapse id="collapse-filtre" class="mb-2">
      <b-card class="filtre-resultats">
        <b-row>
          <b-col lg="3" md="10" sm="12">
            <b-form-group id="input-group-2" label="Enquesta: " label-size="sm" label-for="input-filtre-enquesta" label-cols="4">
              <b-form-select size="sm" id="input-filtre-enquesta" v-model="filtre.idEnquesta" @change="onChangeEnquestaFiltre()">
                <b-form-select-option :value=null>-- Totes --</b-form-select-option>
                <template v-for="(item,idx) in enquestes">
                  <b-form-select-option v-bind:key='"enq"-idx' :value=item.idEnquesta>{{item.descripcio}}</b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col lg="3" md="10" sm="12">
            <b-form-group id="input-group-2" label="Activació: " label-size="sm" label-for="input-filtre-activacio" label-cols="4">
              <b-form-select size="sm" id="input-filtre-activacio" v-model="filtre.idActivacio">
                <b-form-select-option :value=null>-- Totes --</b-form-select-option>
                <template v-for="(item,idx) in activacions">
                  <b-form-select-option v-bind:key='"act"-idx-item.mountedTime' :value=item.idActivacio>{{item.descripcio}}</b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col lg="3" md="10" sm="12">

          </b-col>                 
          <b-col lg="3" md="1" sm="12" class="filtre-btn-enquestes">
            <b-button size="sm" variant="outline-primary" @click.prevent="onAfegirFiltre()">
              <b-icon icon="plus" aria-hidden="true"></b-icon>
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="3" md="10" sm="12">
            <b-form-group id="input-group-2" label="Quota: " label-size="sm" label-for="input-filtre-quota" label-cols="4">
              <b-form-select size="sm" id="input-filtre-quota" v-model="filtre.idQuota" @change="onChangeQuotaFiltre()">
                <b-form-select-option :value=null>-- Totes --</b-form-select-option>
                <template v-for="(item,idx) in quotes">
                  <b-form-select-option v-bind:key='"quo"-idx-item.mountedTime' :value=item.idQuota>{{item.descripcio}}</b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>  
        <b-row>
          <b-col lg="2" md="2" sm="12">
            <VariableAbs v-bind:key='lastFilterTime' v-bind:initialValue="getVariable('abs')" v-on:variable-editada="onVariableFiltreEditada" v-on:variable-eliminada="onVariableFiltreEliminada" />            
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <VariableRegioSanitaria v-bind:key='lastFilterTime' v-bind:initialValue="getVariable('regio-sanitaria')"  v-on:variable-editada="onVariableFiltreEditada" v-on:variable-eliminada="onVariableFiltreEliminada" />            
          </b-col>
          <b-col lg="5" md="5" sm="12">
            <VariableEdat v-bind:key='lastFilterTime' v-bind:initialValue="getVariable('edat')" v-on:variable-editada="onVariableFiltreEditada" v-on:variable-eliminada="onVariableFiltreEliminada" />
          </b-col>
          <b-col lg="2" md="2" sm="12">
            <VariableGenere v-bind:key='lastFilterTime' v-bind:initialValue="getVariable('genere')" v-on:variable-editada="onVariableFiltreEditada" v-on:variable-eliminada="onVariableFiltreEliminada" />            
          </b-col>
        </b-row>          
      </b-card>
    </b-collapse>  

  <div class="text-center mt-4" v-if="loadingDataResum && !loadingDataCharts"><b-spinner variant="primary" ></b-spinner></div>
  <b-list-group v-if="!loadingDataResum">
  <b-list-group-item href="#" class="flex-column align-items-start" style="padding-top: 5px;padding-bottom: 5px;"  v-for="(item,idx) in cerca.filtres" v-bind:key='idx+item.addFilterTime'>
    <div class="d-flex w-100 justify-content-between item-filtre-resultats" @mouseover="mouseOver" @mouseleave="mouseLeave">
      <div>
        <h6 class="mb-1">{{getResumEnquestaActivacioFiltre(item)}}</h6>
        <p v-for="(quo,idq) in item.quotes" v-bind:key="idq" class="ml-2 item-filtre-quota">{{getResumQuotaFiltre(item.idEnquesta,quo)}}</p>      
      </div>
      <b-button class="btn-eliminar-filtre-cerca" size="sm" variant="outline-primary" @click.prevent="onEliminarFiltre(idx)">
        <b-icon icon="trash" aria-hidden="true"></b-icon>
      </b-button>      
    </div>
  </b-list-group-item>

  <b-list-group-item href="#" class="flex-column align-items-start"  v-if="cerca.filtres.length==0">
    <div class="d-flex w-100 justify-content-between">
      <h6 class="mb-1">Es mostren els resultats de totes les enquestes.</h6>
    </div>
  </b-list-group-item>
  </b-list-group>

    <div class="text-center mt-4" v-if="loadingDataCharts"><b-spinner variant="primary" ></b-spinner></div>
    <b-row no-gutters v-if="!loadingDataCharts">      

      <b-col lg="6" md="12" sm="12" v-for="(item,idx) in charts" v-bind:key='idx-lastCercaTime'>
        <div class="card shadow mb-2 mt-2 ml-2">
          <div class="card-header py-3" style="text-align: left;">
            <h6 class="m-0 label-titol-chart">{{item.index+"- "}}{{item.titol | etiqueta}}</h6>
          </div>
          <div class="card-body">            
            <DonutsChart :id="`donuts-chart-${idx}`" v-if='item.tipus==="donuts-chart"' :opcions=item.dades.opcions />
            <PieChart :id="`pie-chart-${idx}`" v-if='item.tipus==="pie-chart"' :opcions=item.dades.opcions />
            <DistributionChart :id="`distribution-chart-${idx}`" v-if='item.tipus==="distribution-chart"' :dades=item.dades />            
            <PotenciometreChart :id="`potenciometre-chart-${idx}`" v-if='item.tipus==="potenciometre-chart"' :percentatge=item.dades.percentatge />
          </div>
        </div>
      </b-col>        

    </b-row>             

  </div>
</template>

<script>
import PieChart from "../charts/PieChart";
import DonutsChart from "../charts/DonutsChart";
import DistributionChart from "../charts/DistributionChart";
import PotenciometreChart from "../charts/PotenciometreChart";
import enquestaService from "../../services/EnquestaService";
import VariableRegioSanitaria from "./VariableRegioSanitaria";
import VariableEdat from "./VariableEdat";
import VariableGenere from "./VariableGenere";
import VariableAbs from "./VariableAbs";
//import resultatsDummy from "../../services/resultats_dummy.json";
//import enquestesDummy from "../../services/resultats_dummy0.json";

export default {
  name: "resultats",
  components: {
    PieChart,
    DistributionChart,
    PotenciometreChart,
    DonutsChart,
    VariableRegioSanitaria,VariableGenere,VariableEdat,VariableAbs
  },  
  data() {
    return {
      loadingDataResum:true,
      loadingDataCharts:true,
      lastCercaTime:new Date().getTime(),
      lastFilterTime:new Date().getTime(),
      charts :[],
      cerca : { 
        filtres : {},
        config: {}
      },
      filtre:{ 
        idEnquesta:null,
        idActivacio:null,     
        idQuota:null,   
        variables:[]
      },
      enquestes: [],
      activacions: [],
      quotes: []
    };
  },
  methods: {
    async cercaResultats(){      

        try{
          this.cerca.config.disaggregatedQuestions = [];
          this.cerca.config.onlyTheFirstSubmitsByQuota=false;
          this.cerca.config.submitsByQuota=true;
          this.cerca.config.ignoredOptionsDonutsChart=["9"];
          this.cerca.config.ignoredAnswersDonutsChart=["No vaig estar a la llista d’espera"];
          if(this.esFiltreAgregat()){
            this.cerca.config.disaggregatedQuestions = [6,7];
          }
          this.loadingDataCharts = true;
          const response = await enquestaService.getResultats(this.cerca);
          this.charts = response.data.charts;
          this.lastCercaTime = new Date().getTime();
          this.loadingDataCharts = false;
        }catch(e){
          console.log(e);
        }

    },
    async listEnquestes() {      

        try{
          this.loadingDataResum = true;
          this.enquestes = [];
          const response = await enquestaService.listEnquestes({});
          
          for(var i = 0;i<response.data.length;i++){
            var e = response.data[i];
              var m = false;
              if(e.activacions && e.activacions.length>0){
                  if(e.activacions.filter(a=>a.estat == 2 || a.estat == 3 ).length>0){
                    m = true;
                  }
              }
              if(m){
                this.enquestes.push(e);
              }
          }
          this.loadingDataResum = false;
          if(this.cerca.filtres){
            this.cerca.filtres.forEach(element => element.addFilterTime = new Date().getTime());
          }
          
        }catch(e){
          console.log(e);
        }      

    },
    onAfegirFiltre(){        

        if(!this.filtre.idEnquesta){
          return;
        }

        var nouFiltreEnquesta = {};
        var nouFiltreQuota = {};
        var nouFiltreActivacio = {};

        //Mirem que el nou filtre sigui coherent amb els que ja hi han
        var grupIdEnquesta = this.cerca.filtres.filter(f=>f.idEnquesta == this.filtre.idEnquesta);

        if(grupIdEnquesta.length>0){
          
          if(!this.filtre.idActivacio){//Si no ve informat idactivacio, no el podem afegir xk és igual o més genèric que lo que tenim prèviamen al filtre
            return;
          }

          if(grupIdEnquesta.filter(f=>f.activacions.filter(a=>a.idActivacio == this.filtre.idActivacio).length>0).length==0){//Si no tenim un filtre previ idEnquesta - idActivacio

            if(grupIdEnquesta.filter(f=>f.activacions.length==0).length>0){
              return;
            }
            nouFiltreEnquesta.idEnquesta = this.filtre.idEnquesta;
            nouFiltreEnquesta.activacions = [];
            nouFiltreEnquesta.quotes = [];
            nouFiltreActivacio.idActivacio = this.filtre.idActivacio;         
            nouFiltreEnquesta.activacions.push(nouFiltreActivacio);

            //Si venen informades les varibles
            if(this.filtre.variables && this.filtre.variables.length>0){ 
              nouFiltreQuota.variables=[];
              this.filtre.variables.forEach(function(v){
                  var nv={};
                  nv.codi = v.codi;
                  nv.valor = v.valor;
                  nouFiltreQuota.variables.push(nv);
              });
              nouFiltreEnquesta.quotes.push(nouFiltreQuota);
            }
            this.cerca.filtres.push(nouFiltreEnquesta);
          }else{

             var existentFiltreEnquesta = grupIdEnquesta.filter(f=>f.activacions.filter(a=>a.idActivacio == this.filtre.idActivacio).length>0)[0];
             if(existentFiltreEnquesta.quotes.length==0){//Si tenim un filtre previ sense quota, és més genèric, no deixem ficar el nou
               return;
             }
             if(this.filtre.variables && this.filtre.variables.length>0){ 
              nouFiltreQuota.variables=[];
              this.filtre.variables.forEach(function(v){
                  var nv={};
                  nv.codi = v.codi;
                  nv.valor = v.valor;
                  nouFiltreQuota.variables.push(nv);
              });
              existentFiltreEnquesta.quotes.push(nouFiltreQuota);              
            }else{
              return;
            }

          }          


        }else{
          //Cas enquesta no afegida a llista de filtres
          nouFiltreEnquesta.idEnquesta = this.filtre.idEnquesta;
          nouFiltreEnquesta.activacions = [];
          nouFiltreEnquesta.quotes = [];

          if(this.filtre.idActivacio){
            nouFiltreActivacio.idActivacio = this.filtre.idActivacio;
            nouFiltreEnquesta.activacions.push(nouFiltreActivacio);
          }

          if(this.filtre.variables && this.filtre.variables.length>0){ 
            nouFiltreQuota.variables=[];
            nouFiltreQuota.variables=this.filtre.variables;
            nouFiltreEnquesta.quotes.push(nouFiltreQuota);
          }


          this.cerca.filtres.push(nouFiltreEnquesta);
          
        }
          
        this.cercaResultats();
        
    },
    onEliminarFiltre(idx){
      this.cerca.filtres.splice(idx, 1);
      this.cercaResultats();
    },
    getResumQuotaFiltre(idEnquesta,q){
      var t=this;
      var resum = "";
      var quotes = this.enquestes.filter(f=>f.idEnquesta == idEnquesta)[0].quotes;
      var variables = [];
      if(!q.variables && q.idQuota){
        variables = quotes.filter(qu=>qu.idQuota == q.idQuota)[0].variables;
      }else if(q.variables){
        variables = q.variables;
      }
      variables.forEach(function(v){
        if(v.codi =='regio-sanitaria'){
          resum = resum +" - "+t.$t('variables.regio.'+v.valor);
        }      
        if(v.codi =='genere'){
          resum = resum +" - "+t.$t('variables.genere.'+v.valor);
        }       
        if(v.codi =='abs'){
          console.log("v.valor: ");
          console.log(v.valor);
          resum = resum +" - "+ v.valor;
        }   
        if(v.codi =='edat'){
          if(v.valor.limitInferior){
            resum = resum +" - De "+v.valor.limitInferior;
              if(v.valor.limitSuperior){
                resum = resum +" a "+v.valor.limitSuperior +" anys";
              }else{
                resum = resum +" anys o més";
              }
          }else{
              if(v.valor.limitSuperior){
                resum = resum +" Fins a "+v.valor.limitSuperior;
              }
          }

        }          
      });

      return resum;
    },
    getResumEnquestaActivacioFiltre(item){

      var resum = "";
      var e = this.enquestes.filter(f=>f.idEnquesta == item.idEnquesta)[0];
      if(e){

        resum = e.descripcio;

        if(item.activacions && item.activacions.length>0){ 
          resum = resum + " ("
          var resAct = "";
          item.activacions.forEach(function(a){          
            var ac = e.activacions.filter(act=>act.idActivacio == a.idActivacio)[0];
            if(resAct.length!=0){
              resAct = resAct + ", "
            }
            resAct = resAct + ac.descripcio;
          });
          resum = resum +resAct+ ")";
        }        
        
      }
      return resum;
    },
    onChangeEnquestaFiltre(){
      this.filtre.idActivacio = null;
      this.filtre.idQuota = null;
      this.filtre.variables = null;
      this.lastFilterTime = new Date().getTime();      
      this.activacions = [];      
      this.quotes = [];      
      if(this.filtre.idEnquesta){
        this.activacions = this.enquestes.filter(f=>f.idEnquesta ==this.filtre.idEnquesta)[0].activacions.filter(a=>a.estat == 2 || a.estat == 3 );
        this.quotes = this.enquestes.filter(f=>f.idEnquesta ==this.filtre.idEnquesta)[0].quotes;
      }
    },
    onChangeQuotaFiltre(){
      if(this.filtre.idQuota){
        this.filtre.variables = this.quotes.filter(q=>q.idQuota ==this.filtre.idQuota)[0].variables;
      }else{
        this.filtre.variables = [];
      }
      this.lastFilterTime = new Date().getTime();
    },
    getVariable(codi){
      let i;
      if(!this.filtre.variables) return null;
      for(i = 0; i < this.filtre.variables.length; i++) {
        if(this.filtre.variables[i].codi === codi){
          return this.filtre.variables[i];          
        }
      }
      return null;
    },
    onVariableFiltreEditada(evt){

      
      if(!this.filtre.variables){
        this.filtre.variables = [];
        this.filtre.variables.push(evt);
      }else{
        if(this.filtre.variables.filter(v=>v.codi ===evt.codi).length>0){
          this.filtre.variables.filter(v=>v.codi ===evt.codi)[0].valor = evt.valor;
        }else{
          this.filtre.variables.push(evt);
        } 
      }
      
    },
    onVariableFiltreEliminada(codi){
      if(this.filtre.variables){
        this.filtre.variables = this.filtre.variables.filter(v=>v.codi != codi);
      }
    },    
    esFiltreAgregat(){
        var idsEnquesta = [];
        var i = 0;
        for(i=0;i<this.cerca.filtres.length;i++){
          if(idsEnquesta.filter(f=>f==this.cerca.filtres[i].idEnquesta).length==0){
            idsEnquesta.push(this.cerca.filtres[i].idEnquesta);
          }
        }
        
        return idsEnquesta.length!=1
    },
    mouseOver(evt){
      evt.srcElement.classList.add('item-filtre-resultats-hover');
    },
    mouseLeave(evt){
      evt.srcElement.classList.remove('item-filtre-resultats-hover');
    }
  },
  mounted() {
      this.cerca = this.$route.params;

      if(this.cerca.filtres){
        this.cerca.filtres.forEach(function(element){
          element.addFilterTime = new Date().getTime();
          if(!element.activacions){
            element.activacions = [];
          }
          if(!element.quotes){
            element.quotes = [];
          }          
        });
      }else{
        this.cerca.filtres = [];
      }

      if(!this.cerca.config){
        this.cerca.config = {};
      }
      this.cercaResultats();
      this.listEnquestes();
  }
};
</script>

<style>
.label-titol-chart{
  font-weight: 500;
  font-size: 14px;
}
.botonera-resultats {
  text-align: right;
  margin-top: 10px;  
  margin-bottom: 10px
}
.btn-eliminar-filtre-cerca{
  margin-top: 0px;
  display: none;
}
.item-filtre-quota{  
  margin-bottom: 1px;
  font-size: 14px;
  text-align: left;
}
.item-filtre-resultats{
  text-align: left;
}
.item-filtre-resultats-hover .btn-eliminar-filtre-cerca{
  display: block;
  text-align: left;
}
</style>